import template from './sw-cms-block-cross-selling.html.twig';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
